import styled from 'styled-components'
import React from 'react'

interface BannerProps {
  img?: string
  onClick?: () => void

  alt?: string
  id?: string
}

function BannerItems({ img, onClick, alt, id }: BannerProps) {
  if (!img) return null

  return (
    <BannerWrap onClick={onClick} id={id}>
      <BannerImg src={img} onClick={onClick} alt={alt} />
    </BannerWrap>
  )
}

const BannerContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const BannerWrap = styled.section`
  display: flex;
  width: 100%;
`

const BannerImg = styled.img`
  width: 100%;
  height: 100%;
`

export const Banner = {
  Items: BannerItems,
  Container: BannerContainer,
}
